var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 40.968,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5.121 40.541 C 2.528 40.541 0.427 40.541 0.427 40.541 L 0.427 0.427 C 0.427 0.427 2.528 0.427 5.121 0.427 L 54.624 0.427 C 57.216 0.427 59.318 0.427 59.318 0.427 L 59.318 40.541 C 59.318 40.541 57.216 40.541 54.624 40.541 Z",
    fill: "rgb(255,255,255)",
    strokeWidth: 0.8535483870967742,
    stroke: "rgb(217,217,217)",
    strokeMiterlimit: 3.225806451612903,
    strokeDasharray: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.137 27.753 L 14.518 27.753 L 11.804 17.398 C 11.675 16.922 11.401 16.501 10.999 16.303 C 9.995 15.804 8.888 15.407 7.681 15.207 L 7.681 14.808 L 13.512 14.808 C 14.266 14.805 14.909 15.356 15.021 16.102 L 16.429 23.571 L 20.046 14.808 L 23.565 14.808 Z M 25.577 27.753 L 22.159 27.753 L 24.974 14.808 L 28.392 14.808 Z M 32.814 18.394 C 32.915 17.697 33.518 17.298 34.222 17.298 C 35.329 17.198 36.534 17.398 37.54 17.895 L 38.144 15.108 C 37.137 14.71 36.031 14.509 35.027 14.509 C 31.709 14.509 29.295 16.303 29.295 18.791 C 29.295 20.684 31.005 21.678 32.212 22.277 C 33.518 22.874 34.021 23.273 33.921 23.87 C 33.921 24.765 32.915 25.164 31.911 25.164 C 30.704 25.164 29.496 24.865 28.392 24.367 L 27.788 27.155 C 28.995 27.653 30.301 27.853 31.508 27.853 C 35.228 27.951 37.54 26.16 37.54 23.471 C 37.54 20.085 32.814 19.887 32.814 18.394 Z M 49.503 27.753 L 46.789 14.808 L 43.873 14.808 C 43.27 14.808 42.666 15.207 42.465 15.804 L 37.439 27.753 L 40.958 27.753 L 41.66 25.861 L 45.984 25.861 L 46.386 27.753 Z M 44.376 18.294 L 45.38 23.172 L 42.566 23.172 Z",
    fill: "rgb(23,43,133)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.5c78510b.svg";
export { ForwardRef as ReactComponent };